export const FooterState = Object.freeze({
  Idle: Symbol("idle"),
  Processing: Symbol("processing"),
  Error: Symbol("error"),
  Success: Symbol("success"),
});
